import { FormHelperTextProps } from '@mui/material/FormHelperText';
import React from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import styled from 'styled-components';

import { FormHelperText } from '@mui/material';

export interface MessagePair {
    message: string
    params?: string[]
}

interface Props {
    messages?: MessagePair[]
}

const FormErrorMessage: React.FC<Props & FormHelperTextProps> = (props) => {

    const formatEmbeddedParameters = (messagePair: MessagePair): string => {
        if (!messagePair.params) {
            return messagePair.message
        }

        let message = messagePair.message
        messagePair.params.forEach((param, i) => {
            message = message.replace(`{${i}}`, param)
        })
        return message
    }

    const createMessage = (pairs?: MessagePair[]): Nullable<string[]> => {
        if (!pairs) {
            return null
        }

        return pairs.map((messagePair) => {
            return formatEmbeddedParameters(messagePair)
        }).filter((value, index, self) => self.indexOf(value) === index)
    }

    const embeddedMessages = createMessage(props.messages)
    if (!embeddedMessages) {
        return null
    }

    const {messages, ...rest} = props
    return (<>{
        embeddedMessages.map((message, i) => {
            return <StyledFormHelperText key={i} error {...rest} >{message}</StyledFormHelperText>
        })
    }</>)
}

FormErrorMessage.displayName = 'FormErrorMessage'
export default FormErrorMessage

const StyledFormHelperText = styled(FormHelperText)`
  &.Mui-error {
    white-space: pre-wrap;
  }
`;
